<template>
  <svg class="icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 5V12M12 19V12M5 12H12M12 12H19" stroke-width="2" stroke-linecap="round"/>
  </svg>
</template>